class RecipientFormAccordion extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.recipient-checkbox-input');
    this.fields = this.querySelector('.recipient-fields');
    this.offsetInput = this.querySelector('[name="properties[__shopify_offset]"]');
  }

  connectedCallback() {
    this.checkbox.addEventListener('change', this.handleToggle.bind(this));
    
    if (this.checkbox.checked) {
      this.open();
    } else {
      this.close();
    }
  }

  handleToggle() {
    if (this.checkbox.checked) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.setAttribute('aria-expanded', 'true');
    this.classList.add('is-open');
    
    if (this.offsetInput) {
      this.offsetInput.disabled = false;
      this.offsetInput.value = new Date().getTimezoneOffset().toString();
    }
  }

  close() {
    this.setAttribute('aria-expanded', 'false');
    this.classList.remove('is-open');
    
    if (this.offsetInput) {
      this.offsetInput.disabled = true;
      this.offsetInput.value = '';
    }
  }
}

customElements.define('recipient-form-accordion', RecipientFormAccordion);